import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import HomeFr from '../views/HomeFr.vue'
import HomeIt from '../views/HomeIt.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/best-ecn-broker',
    name: 'home',
    component: Home,
    meta: {title: 'Best ECN Broker | TrioMarkets'}
  },
  {
    path: '/best-ecn-broker/fr',
    name: 'homefr',
    component: HomeFr,
    meta: {title: 'Meilleur courtier ECN | TrioMarkets'}
  },
  {
    path: '/best-ecn-broker/it',
    name: 'homeit',
    component: HomeIt,
    meta: {title: 'Il miglior Broker ECN | TrioMarkets'}
  },
  {
    path: '*',
    redirect: '/best-ecn-broker'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
